module.exports = __webpack_public_path__ + "img/tolstoi.80a8cbb8.jpg";